import { ColDef } from '~components/dataGrids/interfaces/colDef';
import { GridColTypeEnum } from '~components/dataGrids/interfaces/gridColTypeEnum';
import { pagePathSegments } from '~constants';
import { UserRoleEnum } from '~enums';
import { getUserRoleLabel } from '~enums/userRoleEnum';
import { IdReference } from '~interfaces';
import i18n from '~lib/i18n';

interface User extends IdReference {
	emailAddress: string;
	organisationId: string;
	organisationName?: string;
	role: UserRoleEnum;
	firstName: string;
	lastName: string;
	phoneNumber?: string;
	culture: string;
	department?: string;
}

export default User;

export const userGridCols: Record<string, ColDef<User>> = {
	fullName: {
		field: 'firstName',
		headerName: 'entities:general.name',
		gridColType: GridColTypeEnum.Link,
		addIdToPath: true,
		linkPathGetter: (_value: User) => pagePathSegments.Users,
		defaultShown: true,
		valueGetter: (value: User) => `${value.firstName} ${value.lastName}`,
	},
	emailAddress: {
		field: 'emailAddress',
		headerName: 'entities:general.email',
		gridColType: GridColTypeEnum.Regular,
		defaultShown: true,
	},
	phoneNumber: {
		field: 'phoneNumber',
		headerName: 'entities:user.fields.phone',
		gridColType: GridColTypeEnum.Regular,
		defaultShown: true,
	},
	role: {
		field: 'role',
		headerName: 'entities:user.fields.role',
		valueGetter: (value: User) =>
			value.role ?
				getUserRoleLabel(value.role, i18n.t)
			:	i18n.t('general.none', { ns: 'entities' }),
		defaultShown: true,
	},
};
